import PropTypes from "prop-types"
import { useMemo } from "react"
import { useRemarkSync } from "react-remark"
import { Link } from "react-router-dom"

import Button from "components/ui/button"
import { cn } from "styles/utils"

const getComponents = (classNames) => ({
  a: ({ href, ...props }) => (
    <Button asChild className="inline whitespace-normal" text underline>
      <Link target="_blank" to={href} {...props} />
    </Button>
  ),
  h1: ({ ...props }) => <h1 className="h2 mb-8" {...props} />,
  h2: ({ ...props }) => <h2 className="h3 mb-8" {...props} />,
  h3: ({ ...props }) => <h3 className="body-lg mb-8" {...props} />,
  p: ({ ...props }) => (
    <p className={cn(classNames?.paragraphClassName)} {...props} />
  ),
})

const DescriptionMarkdown = ({ children, classNames }) => {
  const components = useMemo(() => getComponents(classNames), [classNames])
  const markdownContent = useRemarkSync(children, {
    rehypeReactOptions: { components },
    suppressHydrationWarning: true,
  })

  return markdownContent
}

DescriptionMarkdown.propTypes = {
  children: PropTypes.string,
  classNames: PropTypes.object,
}

export default DescriptionMarkdown
